import { CommonService } from "./../../services/common.service";
import { ChangeDetectorRef, Component } from "@angular/core";
import { ISearchDropDown } from "../search-dropdown/SearchDropdown";
import { ToastrService } from "ngx-toastr";
import {
  AbstractControl,
  FormGroup,
  UntypedFormBuilder,
  UntypedFormGroup,
  ValidatorFn,
  Validators,
} from "@angular/forms";
import { dataDictionary } from "src/app/dataDictionary";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseComponent } from "../base.component";

declare global {
  interface JQuery {
    modal(action?: string): JQuery;
  }
}
@Component({
  selector: "app-ouk-student-signup",
  templateUrl: "./ouk-student-signup.component.html",
  styleUrls: ["./ouk-student-signup.component.css"],
})
export class OukStudentSignupComponent {
  countrySearchData: ISearchDropDown;
  programSearchData: ISearchDropDown;
  signUpForm: UntypedFormGroup;
  country: Array<any> = [];
  selectedCountry: string = "";
  mobileCodeData: ISearchDropDown;
  countryCode: string = "";
  mobileCode: string = "";
  EMAIL_ADDRESS: string | null = "";
  email: string = "user@example.com"; // replace with your dynamic email
  passwordFeedback: string[] = [];
  confirmPasswordFeedback: string[] = [];
  days: number[] = Array.from({ length: 31 }, (_, i) => i + 1);
  months: number[] = Array.from({ length: 12 }, (_, i) => i + 1);
  years: number[] = Array.from(
    { length: 100 },
    (_, i) => new Date().getFullYear() - i
  );
  selectedDay: any = "";
  selectedMonth: any = "";
  selectedYear: any = "";
  County: Array<any> = [];
  programs: Array<any> = [];
  gender: Array<any> = [];
  selectedProgram: any;
  pay_Load: any = {};
  showPassword: boolean = false;
  isKenyan: boolean = true;
  user_id: any;
  courseId: any;
  constructor(
    private CommonService: CommonService,
    private toastr: ToastrService,
    private fb: UntypedFormBuilder,
    private cdr: ChangeDetectorRef,
    private route: Router,
    private active: ActivatedRoute
  ) {
    this.loadCountry();
    this.initialData();
    this.programData();
    this.signUpOnInit();
    this.initialMobileCodeData();
    this.loadPrograms();
    this.active.queryParams.subscribe((res: any) => {
      this.courseId = res?.id;
    });
  }
  initialData(): void {
    this.countrySearchData = {
      DataList: [],
      SelectedText: "COUNTRY_NAME",
      SelectedId: "COUNTRY_ID",
      DropdownTitle: "",
      EnabledOrDisabled: false,
      PatchId: "0",
      isRequried: false,
      placeholder: "Select a country",
    };
  }
  initialMobileCodeData(): void {
    this.mobileCodeData = {
      DataList: [],
      SelectedText: "COUNTRY_CONNECTING_CODE",
      SelectedId: "COUNTRY_ID",
      DropdownTitle: "",
      EnabledOrDisabled: true,
      PatchId: "0",
      isRequried: false,
      placeholder: "Country Code",
    };
  }
  programData(): void {
    this.programSearchData = {
      DataList: [],
      SelectedText: "COURSE_NAME",
      SelectedId: "COURSE_ID",
      DropdownTitle: "",
      EnabledOrDisabled: false,
      PatchId: "0",
      isRequried: false,
      placeholder: "Select Program",
    };
  }
  togglePassword() {
    this.showPassword = !this.showPassword;
  }
  signUpOnInit() {
    this.signUpForm = this.fb.group(
      {
        FirstName: ["", [Validators.required, Validators.maxLength(100)]],
        LastName: ["", [Validators.required, Validators.maxLength(100)]],
        middlename: [""],
        Gender: ["", [Validators.required]],
        AssessorCourseId: ["", [Validators.required]],
        PLACE_OF_BIRTH: ["", [Validators.required]],
        id_passport: ["", [Validators.required]],
        Mobileno: ["", [Validators.required, Validators.pattern("^[0-9]*$")]],
        password: ["", [this.passwordValidator()]],
        confirmPassword: [""], // new field
        COUNTIES_ID: ["0"],
        REFERRAL_CODE: [""],
        PLEASE_CONFIRM: [""],
        IS_DISABILITY: [false],
        DISABILITY_DESCRIPTION: [""],
        UserName: [
          "",
          [
            Validators.required,
            Validators.pattern(
              "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,4}$"
            ),
          ],
        ],
        role: [true],
        Company_Name: [""],
        regType: ["1"],
        Company_id: [0],
      },
      { validators: this.passwordsMatchValidator }
    );
  }
  loadCountry() {
    this.CommonService.activateSpinner();
    this.country = [];
    this.CommonService.postCall("ClustersMaster/GetCountryList", {}).subscribe(
      (res: any) => {
        // this.country = res.sort((a: any, b: any) => a.COUNTRY_CONNECTING_CODE.localeCompare(b.COUNTRY_CONNECTING_CODE));
        this.country = res.sort((a: any, b: any) =>
          a.COUNTRY_NAME.localeCompare(b.COUNTRY_NAME)
        );
        this.selectedCountry = res.find(
          (e) => e.COUNTRY_NAME === "Kenya"
        )?.COUNTRY_ID;
        this.countrySearchData = {
          ...this.countrySearchData,
          DataList: this.country,
          PatchId: this.selectedCountry,
        };
        this.mobileCodeData = {
          ...this.mobileCodeData,
          DataList: this.country,
          PatchId: this.selectedCountry,
        };
        this.changeSearchDropdown(this.selectedCountry);
        this.changeCounty(this.selectedCountry);

        this.CommonService.deactivateSpinner();
      }
    );
  }
  changeSearchDropdown(data: any) {
    this.countryCode = data.COUNTRY_ID;
    if (+this.countryCode == 336) {
      //Kenya
      this.isKenyan = true;
    } else {
      this.isKenyan = false;
      this.signUpForm.get("COUNTIES_ID")?.setValue("0");
    }
    this.changeMobileCodeSearchDropdown(data);
  }
  changeMobileCodeSearchDropdown(data: any) {
    this.mobileCode = data.COUNTRY_ID;
    this.mobileCodeData = {
      ...this.mobileCodeData,
      DataList: this.country,
      PatchId: this.mobileCode,
    };
  }
  changeCounty(cId: any) {
    let county = this.country.find(
      (e: any) => e.COUNTRY_ID == cId
    )?.COUNTRY_NAME;
    this.CommonService.postCall("ClustersMaster/GetCountiesListByKenya", {
      COUNTRY_NAME: county,
    }).subscribe(
      (res: any) => {
        this.County = res;
      },
      (err: any) => {
        this.toastr.error(err.error ? err.error : "No County's found!");
      }
    );
  }
  mobileValidation(event: any) {
    if (event.target.value.charAt(0) === "0") {
      this.toastr.error("Mobile number cannot start with zero.");
      this.signUpForm.controls["Mobileno"].setValue("");
    }
  }
  onKeyPress(event: any) {
    const inputElement = event.target as HTMLInputElement;
    const currentValue = inputElement.value;

    // Allow only numbers (0-9) and restrict the length to 12 characters
    const charCode = event.which ? event.which : event.keyCode;
    const isNumber = charCode >= 48 && charCode <= 57;

    if (!isNumber || currentValue.length >= 12) {
      event.preventDefault();
    }

    // const charCode = event.which ? event.which : event.keyCode;

    // Allow only numbers (0-9) and navigation keys
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData || (window as any).clipboardData;
    let pastedText = clipboardData.getData("text");

    // Remove any non-numeric characters from the pasted text
    const sanitizedText = pastedText.replace(/\D/g, "");

    // Get the input element and its current value
    const inputElement: any = event.target as HTMLInputElement;
    const currentValue = inputElement.value;

    // Limit the combined length of the current value and pasted text to 12 characters
    const allowedLength = 12 - currentValue.length;

    // Trim the pasted text if it exceeds the allowed length
    const trimmedText = sanitizedText.substring(0, allowedLength);

    // Prevent the default paste action
    event.preventDefault();

    // Manually set the input value with the sanitized and trimmed text
    const newValue =
      currentValue.slice(0, inputElement.selectionStart) +
      trimmedText +
      currentValue.slice(inputElement.selectionEnd);

    inputElement.value = newValue;

    // Optionally, update the form control if needed
    this.signUpForm.controls["Mobileno"].setValue(newValue);
  }
  get f() {
    return this.signUpForm.controls;
  }
  verifyEmail() {
    $("#emailVerifyModal").modal("show");
  }
  numberValidate(event: any) {
    event.target.value = event.target.value.replace(/[^0-9]*/g, "");
  }
  nameValidate(event: any) {
    // Allow letters, spaces, dots, hyphens, apostrophes, and ampersands
    event.target.value = event.target.value.replace(
      /[^A-Za-z.\- '&**\d**]*/g,
      ""
    );
  }
  validateEmail(event: any) {
    let val = event.target.value;
    let exp = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

    if (new RegExp(exp).test(val)) {
      // Check if there are numbers after "@" symbol
      let parts = val.split("@");
      if (parts.length === 2 && /\d/.test(parts[1])) {
        this.signUpForm.get("UserName").setValue(null);
        this.toastr.warning('Numbers are not allowed after "@"');
        return;
      } else {
        this.signUpForm.get("UserName").setValue(val);
      }
    } else {
      this.signUpForm.get("UserName").setValue(null);
      this.toastr.warning(
        "Invalid email credentials, please enter a valid email"
      );
      return;
    }
  }
  passwordValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const value: string = control.value || "";
      const email = control.parent?.get("UserName")?.value || "";
      const errors: any = {};

      if (!/[A-Z]/.test(value))
        errors.uppercase = "Password must contain an uppercase letter.";
      if (!/[a-z]/.test(value))
        errors.lowercase = "Password must contain a lowercase letter.";
      if (!/\d/.test(value)) errors.number = "Password must contain a number.";
      if (!/[!@#$%^&*(),.?":{}|<>]/.test(value))
        errors.special = "Password must contain a special character.";
      if (value.length < 8)
        errors.length = "Password must be at least 8 characters long.";
      if (email && value.toLowerCase().includes(email.toLowerCase()))
        errors.email = "Password must not contain your email.";

      return Object.keys(errors).length ? errors : null;
    };
  }

  // checkPassword() {
  //   const errors = this.signUpForm.get("password")?.errors;
  //   if (errors) {
  //     this.passwordFeedback = Object.values(errors);
  //   } else {
  //     this.passwordFeedback = ["Password looks good!"];
  //   }
  // }
  checkPassword() {
    const control = this.signUpForm.get("password");
    const errors = control?.errors;

    if (errors) {
      this.passwordFeedback = Object.values(errors);

      // Show popup alert if invalid
      const errorMessage = this.passwordFeedback.join("\n");
      // this.toastr.error("Password requirements not met:\n" + errorMessage);
      // alert("Password requirements not met:\n" + errorMessage);
    } else {
      this.passwordFeedback = ["Password looks good!"];
    }
  }

  // Cross-field validator
  passwordsMatchValidator(group: FormGroup) {
    const password = group.get("password")?.value;
    const confirmPassword = group.get("confirmPassword")?.value;

    return password === confirmPassword ? null : { passwordsMismatch: true };
  }
  checkConfirmPassword() {
    if (this.signUpForm.hasError("passwordsMismatch")) {
      this.confirmPasswordFeedback = ["Passwords do not match!"];
    } else {
      this.confirmPasswordFeedback = ["Passwords match!"];
    }
  }
  validateAge() {
    const minAge = 12;
    if (!this.isValidDate()) {
      this.toastr.error("The selected date is invalid.");
      this.selectedDay = "";
      this.selectedMonth = "";
      setTimeout(() => {
        this.selectedYear = "";
      }, 20);
      this.cdr.detectChanges();
      return;
    }

    const age = this.calculateAge();
    if (age >= minAge) {
    } else {
      this.toastr.error("Age must be at least 12 years.");
      this.selectedDay = "";
      this.selectedMonth = "";
      setTimeout(() => {
        this.selectedYear = "";
      }, 20);
      this.cdr.detectChanges();
      return;
    }
  }
  isValidDate(): boolean {
    const day = parseInt(this.selectedDay, 10);
    const month = parseInt(this.selectedMonth, 10);
    const year = parseInt(this.selectedYear ?? "", 10);

    if (isNaN(day) || isNaN(month) || isNaN(year)) {
      return false; // Invalid input
    }

    // Create a date object with the selected values
    const date = new Date(year, month - 1, day);

    // Check if the created date matches the input values (handles month overflow cases)
    return (
      date.getFullYear() === year &&
      date.getMonth() === month - 1 &&
      date.getDate() === day
    );
  }
  calculateAge(): number {
    const birthDate = new Date(
      +this.selectedYear!,
      this.selectedMonth - 1,
      this.selectedDay
    );
    const today = new Date();
    const age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      return age - 1;
    }

    return age;
  }
  loadPrograms() {
    this.programs = [];
    this.CommonService.postCall("Courses/GetAllCoursesList", {
      TNT_CODE: 88968955,
    }).subscribe((res: any) => {
      this.programs = res;
      if (res.length)
        this.programSearchData = {
          ...this.programSearchData,
          DataList: this.programs,
          PatchId: this.courseId,
        };
      this.getgender();
    });
  }
  changeProgramDropdown(data: any) {
    this.selectedProgram = data.COURSE_ID;
  }
  getgender() {
    this.CommonService.postCall("GetDictionaryByKey", {
      DictionaryCode: dataDictionary.Gender,
    }).subscribe((res) => {
      this.gender = res;
    });
  }
  onSubmit() {
    // this.submitted = true;
    // if (this.signUpForm.invalid) {
    //   this.toastr.warning('Please Enter All Mandatory Fields', 'SignUp');
    //   return;
    // }

    let signUpData = this.signUpForm.getRawValue();

    let [payLoad, URL] = [{}, ""];
    const month = this.selectedMonth?.toString().padStart(2, "0");
    const day = this.selectedDay?.toString().padStart(2, "0");
    let selectedDob = `${this.selectedYear}-${month}-${day}`;
    // const TENANT_CODE = this.getTenantCode(+sessionStorage.company_id);
    if (!signUpData.role) {
      //Tutor Level
      URL = "TenantRegistration/Create";
      payLoad = {
        TNT_NAME: signUpData.name?.trim(),
        TNT_STATUS: true,
        TenantLogoUrl: "",
        SHOWLOGO: false,
        allow_proctoring: false,
        allow_exampad: false,
        TNT_CREATEDBY: "12345678",
        Mobileno: signUpData.mobile?.trim(),
        emailid: signUpData.email?.trim(),
        Company_Name: signUpData.Company_Name?.trim() || "",
        RoleId: +signUpData.regType == 1 ? 25 : 24,
        country_id: this.countryCode,
        MobileNo_Code_Id: this.mobileCode,
        // RoleId: 25//Tutor
      };
      // console.log(payLoad);
    } else {
      //Student Level
      URL = "Registration/SaveRegistration";
      payLoad = {
        UserName: signUpData.UserName?.trim(),
        password: signUpData.password?.trim(),
        confirmPassword: signUpData.confirmPassword?.trim(),
        AssessorCourseId: this.selectedProgram,
        Gender: signUpData.Gender,
        FirstName: signUpData.FirstName?.trim(),
        LastName: signUpData.LastName?.trim(),
        middlename: signUpData.middlename?.trim(),
        id_passport: signUpData.id_passport?.trim(),
        country_id: this.countryCode,
        MobileNo_Code_Id: this.mobileCode,
        Mobileno: signUpData.Mobileno?.trim(),
        COUNTIES_ID: signUpData.COUNTIES_ID || 0,
        REFERRAL_CODE: signUpData.REFERRAL_CODE,
        PLEASE_CONFIRM: signUpData.PLEASE_CONFIRM,
        PLACE_OF_BIRTH: signUpData.PLACE_OF_BIRTH,
        IS_DISABILITY: Boolean(signUpData.IS_DISABILITY),
        dob: selectedDob,
        Role: 3, //Member Or Student
        TENANT_CODE: 88968955,
        UserType: 26, //Student
        // Role: 3,//Member Or Trainee Or Student
        Timezone: "India Standard Time",
        // CREATEDBY: 88968955,
        // Company_id: +sessionStorage.company_id,
        // dob
      };
    }
    if (
      month == "00" ||
      day == "00" ||
      this.selectedYear == "null" ||
      this.selectedYear == "" ||
      this.selectedYear == null
    ) {
      return this.toastr.warning("DOB is mandatory!");
    }
    this.pay_Load = payLoad;
    //Open Address Model
    this.getAddressDetails(this.pay_Load);
    // this.isLoginDetailsSubmitted = true;
  }
  getAddressDetails(data: any) {
    // this.isLoginDetailsSubmitted = false;
    // console.log("Address Details:=", data);
    if (data == false || data == null) return;
    let URL = "Registration/SaveRegistration";

    let value = this.pay_Load;
    if (value.password == "") {
      return this.toastr.warning("Password is mandatory");
    }
    if (!value.AssessorCourseId) {
      return this.toastr.warning("Program is mandatory");
    }
    if (value.password != value.confirmPassword) {
      return this.toastr.warning(
        "Password and confirm password do not matched"
      );
    }
    this.EMAIL_ADDRESS = value.UserName;
    if (value.FirstName == "") {
      this.toastr.warning("First Name is Mandatory");
      return;
    } else if (value.LastName == "") {
      this.toastr.warning("Last Name is Mandatory");
      return;
    } else if (
      value.country_id == 0 ||
      value.country_id == null ||
      value.country_id == undefined
    ) {
      this.toastr.warning("Country is Mandatory");
      return;
    } else if (
      (value.COUNTIES_ID == 0 ||
        value.COUNTIES_ID == null ||
        value.COUNTIES_ID == undefined) &&
      value.country_id == 336
    ) {
      this.toastr.warning("County is Mandatory");
      return;
    } else if (
      value.MobileNo_Code_Id == 0 ||
      value.MobileNo_Code_Id == null ||
      value.MobileNo_Code_Id == undefined
    ) {
      this.toastr.warning("Mobile code is Mandatory");
      return;
    } else if (value.Mobileno == "") {
      this.toastr.warning("Mobile Number is Mandatory");
      return;
    } else if (!/^\d+$/.test(value.Mobileno)) {
      this.toastr.warning("Mobile number must contain only numbers");
      return;
    } else if (
      value.UserName == "" ||
      value.UserName == undefined ||
      value.UserName == null
    ) {
      this.toastr.warning("Email is Mandatory");
      return;
    } else if (value.PLEASE_CONFIRM == "") {
      this.toastr.warning("Please Confirm the acknowledge");
      return;
    } else if (value.PLACE_OF_BIRTH == "") {
      this.toastr.warning("Place of Birth is mandatory");
      return;
    } else if (value.id_passport == "") {
      this.toastr.warning("ID Number/Birth certificate/Passport is mandatory");
      return;
    }
    this.CommonService.activateSpinner();
    this.CommonService.postCall(URL, this.pay_Load).subscribe(
      (res: any) => {
        if (
          +this.pay_Load.UserType == 26 &&
          res.message == "Registration Successful"
        ) {
          data.TENANTCODE = res.TENANT_CODE;
          data.USERID = res.userID;
          this.CommonService.postCall("Account/UpdateAddress", data).subscribe(
            (res) => {
              this.toastr.success("Created Successfully");
            }
          );
        }

        // if (this.pay_Load["RoleId"] == 25) {
        //   this.checkSamvaadUserExists(signUpData.email, this.pay_Load, res);
        // }
        this.clear();
        this.CommonService.deactivateSpinner();
        this.toastr.success(
          "Your registration has been successful! Please check your email and verify."
        );
        this.user_id = res?.USER_ID;
        this.CommonService.trackEvent("Profile", "Sign up Clicked");
        this.verifyEmail();
        // $("#finalPopup").modal("show");
        // setTimeout(() => {
        //   this.route.navigate(["/login"]);
        // }, 1000);
        // setTimeout(() => {
        //   this.route.navigate(["/login"]);
        // }, 500);
      },
      (err) => {
        this.toastr.error(err.error.MESSAGE);
        this.CommonService.deactivateSpinner();
      }
    );
  }
  clear() {
    this.signUpOnInit();
    this.programSearchData = {
      ...this.programSearchData,
      DataList: [],
    };
    this.loadPrograms();
    // this.submitted = false;
  }
  disablePaste(event: ClipboardEvent) {
    event.preventDefault();
    // alert("Paste is disabled for this field.");
  }

  disableCopy(event: ClipboardEvent) {
    event.preventDefault();
  }

  disableCut(event: ClipboardEvent) {
    event.preventDefault();
  }
  closeModal() {
    this.route.navigate(["/login"]);
  }
  updateVerification() {
    if (!this.user_id) return;

    this.CommonService.activateSpinner();
    this.CommonService.postCall("Registration/UpdateVerificationDate", {
      USER_ID: this.user_id,
    }).subscribe(
      (res: any) => {
        this.toastr.success(res.message);
        this.route.navigate(["/login"]);
        this.CommonService.deactivateSpinner();
      },
      (e) => {
        this.toastr.error(e.error.message);
        this.CommonService.deactivateSpinner();
      }
    );
  }
  noSpecialCharValidation(event: KeyboardEvent): void {
    const inputChar = event.key;

    // Allow only letters (a-z, A-Z), numbers (0-9), and space
    const isValid = /^[a-zA-Z0-9\s]$/.test(inputChar);

    if (!isValid) {
      event.preventDefault(); // Block special characters
    }
  }
  blockSpace(event: KeyboardEvent) {
    if (event.key === " ") {
      event.preventDefault();
    }
  }
}
